const setupChapterReferrals = function setupChapterReferrals(chapter, prefixMap, parentPrefix) {
    if (!prefixMap) prefixMap = Object.create(null)
    if (!parentPrefix) parentPrefix = null
    let prefix = parentPrefix
    if (parentPrefix == null) {
        prefix = chapter.prefix
    } else if (chapter.prefix != null) {
        prefix = parentPrefix + chapter.prefix
    }
    if (!prefixMap[prefix]) prefixMap[prefix] = 0

    chapter.items.forEach(item => {
        prefixMap[prefix]++
        item.referral = prefix + prefixMap[prefix]
    })
    chapter.children.forEach(child => {
        setupChapterReferrals(child, prefixMap, prefix)
    })
    return chapter
}


export default {
    locations: {
        title: 'Standorte|Standort',
        cacheTtl: Infinity,
        relations: {
            cartes: {
                type: 'ManyToOne',
                collection: 'location_cartes',
                fetch: 'embed',
            }
        },
    },
    cartes: {
        title: 'Speisekarten|Speisekarte',
        fields: [
            'title',
            'description',
            'chapters',
        ],
        idFields: ['id'],
        cacheTtl: Infinity,
        relations: {
            chapters: {
                type: 'OneToMany',
                collection: 'carte_chapters',
                fetch: 'embed',
            }
        },
        parse: (carte) => {
            let prefixMap = {}
            carte.chapters.forEach(chapter => {
                setupChapterReferrals(chapter, prefixMap)
            })
        },
    },
    location_cartes: {
        fields: [
            'carte',
            'display',
        ],
        relations: {
            carte: {
                type: 'ManyToOne',
                collection: 'cartes',
                fetch: 'lazy',
            }
        },
    },
    carte_chapters: {
        relations: {
            items: {
                type: 'OneToMany',
                collection: 'carte_items',
                fetch: 'embed',
            },
            children: {
                type: 'OneToMany',
                collection: 'carte_chapters',
                fetch: 'embed',
                recursionDepth: 3,
            }
        },
    },
    carte_items: {
        fields: [
            'count',
            'price',
            'comment',
            'dish',
        ],
        relations: {
            dish: {
                type: 'ManyToOne',
                collection: 'dishes',
                fetch: 'embed',
            },
        },
    },
    dishes: {
        title: 'Gerichte|Gericht',
        cacheTtl: Infinity,
        idFields: ['id'],
    },
}